// @ts-check

import { dateFormatterNoTime, dateFormatterWithTime } from "~/other/Helper";

import zero_support_pic from "~/assets/css/img/Life_Preserver.jpg";
import default_post_img from "~/assets/css/img/default_post_img.png";
import { useCurrentTeam, useCurrentUser } from "~/hooks/reduxHooks";

export default function DefaultPost({ teamSpecific = true}) {
    const currentTeam = useCurrentTeam();
    const currentUser = useCurrentUser();

    const isTeamSpecific = teamSpecific && currentTeam && !["my_teams", "organization_teams"].includes(currentTeam.uuid);
    const postCreationDate = isTeamSpecific ? currentTeam.created_at : currentUser.created_at;

    const openFreshworksWidget = () => {
        if ("FreshworksWidget" in window) {
            // @ts-ignore
            window.FreshworksWidget("open", "article", { id: 70000417523 });
        }
    };

    return (
        <div>
            <div className="panel article thin-border animated fadeIn">
                <div className="panel-body pad-no bulletin-post">
                    <div style={{ display: "inline-block", width: "100%", float: "left" }}>
                        <h3
                            style={{
                                color: "#1d2a35",
                                fontSize: "17px",
                                fontWeight: "600",
                                lineHeight: "1.4",
                                marginBottom: "0px",
                                marginTop: "0px",
                                wordBreak: "break-word",
                            }}
                        >
                            Welcome to ZERO <span role="img">👋</span>
                        </h3>
                        <p
                            style={{
                                wordWrap: "break-word",
                                whiteSpace: "pre-line",
                                color: "#505050",
                                marginBottom: "0px",
                            }}
                        >
                            {!isTeamSpecific ? (
                                <span>
                                    ZERO is a place where everyone on your team can observe, report, and resolve issues
                                    in your workplace. From observations and issue resolution to audits, inspections,
                                    training, and incident reporting, it can all be done seamlessly in ZERO. If you have
                                    any questions, feel free to contact{" "}
                                    <a className="blue-link" href={"mailto:support@teamzero.com"}>
                                        support@teamzero.com
                                    </a>
                                    . Learn more about ZERO{" "}
                                    <a
                                        rel="noopener noreferrer"
                                        onClick={() => openFreshworksWidget()}
                                        className="blue-link"
                                    >
                                        here
                                    </a>
                                    . Welcome!
                                </span>
                            ) : (
                                <span>
                                    {currentTeam?.created_by?.first_name ?? ""}{" "}
                                    {currentTeam?.created_by?.last_name ?? ""} created this team on{" "}
                                    {dateFormatterNoTime(currentTeam?.created_at ?? 0)}, and this is the very first post
                                    in this team. ZERO is a place where everyone on your team can observe, report, and
                                    resolve issues in your workplace. From observations and issue resolution to audits,
                                    inspections, training, and incident reporting, it can all be done seamlessly in
                                    ZERO. If you have any questions, feel free to contact{" "}
                                    <a className="blue-link" href={"mailto:support@teamzero.com"}>
                                        support@teamzero.com
                                    </a>
                                    . Learn more about ZERO{" "}
                                    <a
                                        rel="noopener noreferrer"
                                        onClick={() => openFreshworksWidget()}
                                        className="blue-link"
                                    >
                                        here
                                    </a>
                                    . Welcome!
                                </span>
                            )}
                        </p>
                        <br />
                        <img
                            src={default_post_img}
                            alt="default_post_image"
                            style={{ display: "block", margin: "auto", width: "80%" }}
                        />
                        <br />
                    </div>
                </div>
                <hr className="bulletin" />
                <div className="panel-heading update">
                    <div className="media-left">
                        <img className="img-circle img-sm bulletin" alt="Profile Pic" src={zero_support_pic} />
                    </div>
                    <div className="media-body bulletin">
                        <h3 className="author bulletin truncate name long">ZERO Support</h3>
                        <br />
                        <h3 className="author bulletin date">{dateFormatterWithTime(postCreationDate)}</h3>
                    </div>
                </div>
            </div>
        </div>
    );
}
